import axios from "../http-client/axios";
import { PARAMORE_URL } from "../urls/base-urls";
//const PARAMORE_URL = "http://localhost:8304";

const headers = {
  "content-type": "application/json",
  //"crm": "11656",
  //"codCidades": "4216602,4205407,4211900",
  //"codEspecialidades": "8,99"
}

export async function getById(id) {
  const resp = await axios({
    url: `${PARAMORE_URL}/content/${id}`,
    method: "get",
    data: {},
    headers: headers,
  });

  return resp.data.data;
}

export async function getRelated(id) {
  const resp = await axios({
    url: `${PARAMORE_URL}/content/${id}/related`,
    method: "get",
    headers: headers,
  });

  const items = resp.data ?? [];
  return items;
}


export async function getFile(token) {
  const resp = await axios({
    url: `${PARAMORE_URL}/content/download-image?token=${token}`,
    method: "get",
    responseType: "blob",
    headers: headers,
  });

  return resp.data;
}

export async function getAll(params = {}) {  

  const body = {
    pageNumber: params.page ?? 0,
    pageSize: params.size ?? 20,
    portal: "Cooperado",
    ...(params.category && { category: params.category }),
    ...(params.search && { search: params.search }),
    ...(params.orderBy != null && { orderBy: params.orderBy }),
    ...(params.onlyRequired != null && { onlyRequired: params.onlyRequired }),
    ...(params.period && { period: params.period }),
    ...(params.initialDate && { initialDate: params.initialDate }),
    ...(params.finalDate && { finalDate: params.finalDate }),
  };

  const resp = await axios.post(`${PARAMORE_URL}/content/list-by-crm`, body
    , { headers: headers }
  );
  
  return resp.data;
}

async function loadCoverImage(originalUrl) {
  if (!originalUrl) return null;
  const token = originalUrl.split("/").pop();
  try {
    const blob = await getFile(token);
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.warn("Não foi possível carregar a imagem de capa:", e);
    return null;
  }
}

let homeDataCachePromise = null;

export function clearHomeDataCache() {
  homeDataCachePromise = null;
}

export function getHomeData() {
  if (homeDataCachePromise) return homeDataCachePromise;

  homeDataCachePromise = axios({
    url: `${PARAMORE_URL}/content/home`,
    method: "get",
    headers: headers,
  }).then(async resp => {
    const rawData = resp.data;  
    
    const json = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

    const data = json?.data;
    if (!data) return null;
    const mainImage = await loadCoverImage(data.destaquePrincipal?.imagemCapaUrl);

    return {
      isSuccess: json.isSuccess,
      message: json.message,
      data: {
        featuredContent: {
          id: data.destaquePrincipal?.id,
          title: data.destaquePrincipal?.titulo,
          coverCallout: data.destaquePrincipal?.chamadaCapa,
          image: mainImage,
          createdAt: data.destaquePrincipal?.dataPublicacao
        },
        articles: (data.artigos || []).map(art => ({
          id: art.id,
          title: art.titulo,
          authorName: art.nomeAutor,
          coverCallout: art.chamadaCapa,
          authorImageUrl: art.imagemAutorUrl,
          specialtyAuthor: art.especialidadeAutor,
          contentDate: art.dataPublicacao,
        })),
        news: (data.novidades || []).map(nov => ({
          id: nov.id,
          title: nov.titulo,
          coverCallout: nov.chamadaCapa, 
          coverImageUrl: nov.imagemCapaUrl,
          createdAt: nov.dataPublicacao
        }))
      }
    };
  }).catch(error => {
    homeDataCachePromise = null;
    throw error;
  });

  return homeDataCachePromise;
}

export async function getHighlights(params = {}) {
  const body = {
    pageNumber: params.page ?? 0,
    pageSize: params.size ?? 20,
    portal: "Cooperado",
    ...(params.category && { category: params.category }),
    ...(params.search && { search: params.search }),
    ...(params.orderBy != null && { orderBy: params.orderBy }),
    ...(params.onlyRequired != null && { onlyRequired: params.onlyRequired }),
    ...(params.period && { period: params.period }),
    ...(params.initialDate && { initialDate: params.initialDate }),
    ...(params.finalDate && { finalDate: params.finalDate }),
  };

  const resp = await axios.post(`${PARAMORE_URL}/content/highlights-by-crm`, body, {
    headers: headers,
  });

  return resp.data;
}

export default {
  getById,
  getAll,
  getHighlights,
  getRelated,
  getFile,
  getHomeData,
  clearHomeDataCache
};
